/**
 * Tracks whether the session panel holds unsaved user edits (summary notes),
 * so the app shell can confirm before a patient/session switch wipes them.
 * Module-level because the switch happens in the shell, far from the editor.
 */
let dirty = false;

export function markSessionDirty() {
  dirty = true;
}

export function clearSessionDirty() {
  dirty = false;
}

export function isSessionDirty(): boolean {
  return dirty;
}
